export default __webpack_public_path__ + "static/media/catered-food.cc7a9fa0.svg";